var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 81,
    viewBox: "0 0 41 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "15997 [Converted]-03 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.14415 53.3837C7.84356 54.0064 6.67835 56.6042 7.84356 58.6033C9.00877 60.6023 12.1917 60.936 13.5375 60.6247C14.2998 58.8475 13.9807 57.4888 13.9807 57.4888L9.14254 53.3821L9.14415 53.3837Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9821 57.4905L9.14395 53.3838C7.55165 54.3163 8.71042 55.9465 9.8724 57.0546C11.1279 58.2521 12.6122 59.3075 12.8169 60.7158C13.0876 60.7014 13.3342 60.6711 13.5373 60.6248C14.2996 58.8477 13.9804 57.4905 13.9804 57.4905H13.9821Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6551 44.8542C9.68242 46.1875 8.12236 48.4532 8.15782 51.34C8.18683 53.759 10.5334 57.2046 13.5374 58.2696C15.2425 55.5153 15.1426 53.2432 15.1426 53.2432L11.6551 44.8542Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.1428 53.2432L11.6553 44.8542C11.0155 45.287 10.4208 45.8186 9.90826 46.4366C8.62863 49.8519 13.7069 53.3838 12.7915 57.9455C13.0348 58.0684 13.283 58.1802 13.5377 58.2712C15.2428 55.5169 15.1428 53.2448 15.1428 53.2448V53.2432Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.4672 40.7667C14.2568 41.1659 11.4768 42.4991 11.1625 45.164C10.8482 47.8289 13.1803 52.6716 14.8838 53.8708C16.8564 49.6954 15.4672 40.7651 15.4672 40.7651V40.7667Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4668 40.7667C15.0397 40.9072 14.4176 41.1675 13.7762 41.5587C13.4668 41.9148 13.3088 42.2389 13.1348 42.7211C11.9293 46.0869 14.7496 47.8528 14.0405 53.0517C14.329 53.3997 14.6143 53.6824 14.8834 53.8708C16.856 49.6954 15.4668 40.7651 15.4668 40.7651V40.7667Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.0859 45.8873C30.0859 49.4751 27.828 52.3842 25.0415 52.3842C22.255 52.3842 19.9971 49.4751 19.9971 45.8873C19.9971 42.2995 22.255 39.3904 25.0415 39.3904C27.828 39.3904 30.0859 42.2995 30.0859 45.8873Z",
    fill: "#EDAA89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.1093 56.143C12.1278 60.2816 11.8812 63.1126 12.1939 66.4449C12.5082 69.7771 14.7048 77.8181 16.4083 78.7952L31.3385 78.3961C32.0814 77.6201 30.394 72.0349 31.5206 67.1123C32.5069 62.8028 34.9292 57.9601 36.2281 54.5847C37.5287 51.2077 38.0122 48.9404 37.8865 46.5437C37.7076 43.1236 34.4779 33.882 32.1475 30.1074C29.5915 34.0161 29.2772 42.857 29.2772 42.857C25.8686 44.6341 23.493 49.3874 22.9999 50.8532C16.2745 54.7619 13.1077 56.1446 13.1077 56.1446L13.1093 56.143Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.5201 67.1103C32.5064 62.8009 34.9287 57.9581 36.2277 54.5827C37.5283 51.2057 38.0118 48.9384 37.8861 46.5418C37.7072 43.1217 34.4775 33.88 32.1471 30.1055C31.6378 30.8831 31.2188 31.8586 30.8739 32.9188C32.8207 38.0729 34.6676 43.2127 34.2551 47.3321C33.7168 52.697 30.2195 58.2487 28.9415 63.3118C28.1615 66.403 27.1075 72.4672 28.3065 78.4756L31.338 78.3941C32.081 77.6181 30.3936 72.0329 31.5201 67.1103Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M32.5947 2.20654H2.2832V44.4374H32.5947V2.20654Z",
    fill: "#FFE143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.5964 44.4374H2.2832C19.5373 37.4854 29.0185 22.7895 32.5964 2.20654V44.4374Z",
    fill: "#FFCD43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.6455 52.3172C25.1072 48.7183 23.0218 46.9859 22.4835 43.9202C21.9452 40.8546 22.282 37.0561 20.1966 34.5237C18.1111 31.9914 15.4874 31.9243 14.7476 32.7913C14.0079 33.6583 15.0845 39.4543 15.2859 44.0528C15.4874 48.6512 13.8741 52.916 12.999 56.5804L25.6439 52.3156L25.6455 52.3172Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.1979 34.5254C18.1125 31.9931 15.4888 31.926 14.749 32.793C17.1262 33.0597 18.5154 34.6915 19.6258 37.8577C20.6299 40.7222 19.8837 43.8549 21.542 47.3197C22.5493 49.4241 24.2512 50.0628 25.2826 52.4403C24.7444 48.8413 22.8652 47.0083 22.3269 43.9443C21.7886 40.8787 22.2818 37.0594 20.1979 34.527V34.5254Z",
    fill: "#EDAA89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCard);
export default __webpack_public_path__ + "static/media/yellow-card.dcdb6d5054eba539e3591b6cf4a0f56d.svg";
export { ForwardRef as ReactComponent };